import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { toWebviewRouteName } from '../utils'

/* eslint-disable consistent-return */
export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.meta?.isWebview && from.meta?.isWebview) {
    return navigateTo({
      name: toWebviewRouteName(String(to.name)),
      params: to.params,
    })
  }
})
